/* tslint:disable */
/* eslint-disable */
/**
 * Risk Management System API
 * Risk Management System API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ApiAssignedScreeningAlert
 */
export interface ApiAssignedScreeningAlert {
    /**
     * 
     * @type {number}
     * @memberof ApiAssignedScreeningAlert
     */
    screeningAlertId?: number;
}

/**
 * Check if a given object implements the ApiAssignedScreeningAlert interface.
 */
export function instanceOfApiAssignedScreeningAlert(value: object): value is ApiAssignedScreeningAlert {
    return true;
}

export function ApiAssignedScreeningAlertFromJSON(json: any): ApiAssignedScreeningAlert {
    return ApiAssignedScreeningAlertFromJSONTyped(json, false);
}

export function ApiAssignedScreeningAlertFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiAssignedScreeningAlert {
    if (json == null) {
        return json;
    }
    return {
        
        'screeningAlertId': json['screeningAlertId'] == null ? undefined : json['screeningAlertId'],
    };
}

export function ApiAssignedScreeningAlertToJSON(json: any): ApiAssignedScreeningAlert {
    return ApiAssignedScreeningAlertToJSONTyped(json, false);
}

export function ApiAssignedScreeningAlertToJSONTyped(value?: ApiAssignedScreeningAlert | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'screeningAlertId': value['screeningAlertId'],
    };
}

